import type { CommodityDetail } from '../../../mocks/commodities';

interface Props {
  commodity: CommodityDetail;
}

export default function CommodityApproach({ commodity }: Props) {
  return (
    <section className="bg-[#071525] py-24 px-6 lg:px-16 relative overflow-hidden">
      {/* Grid texture */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div
          className="w-full h-full"
          style={{
            backgroundImage:
              'repeating-linear-gradient(0deg, transparent, transparent 60px, rgba(212,87,26,0.4) 60px, rgba(212,87,26,0.4) 61px), repeating-linear-gradient(90deg, transparent, transparent 60px, rgba(212,87,26,0.4) 60px, rgba(212,87,26,0.4) 61px)',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <div>
            <p className="text-[#d4571a] text-xs font-bold tracking-widest uppercase mb-4">
              Our Approach
            </p>
            <h2 className="text-white text-3xl md:text-4xl font-bold leading-tight mb-6">
              {commodity.approachTitle}
            </h2>
            <p className="text-white/55 text-base leading-relaxed mb-10">
              {commodity.approachText}
            </p>

            {/* Points */}
            {commodity.approachPoints.length > 0 && (
              <ul className="flex flex-col gap-4">
                {commodity.approachPoints.map((point) => (
                  <li key={point} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#d4571a]/20 flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#d4571a] text-xs" />
                    </div>
                    <span className="text-white/70 text-sm leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Image */}
          <div className="rounded-xl overflow-hidden w-full h-[340px] md:h-[420px] lg:h-[460px]">
            <img
              src={commodity.approachImage}
              alt={`${commodity.label} approach`}
              className="w-full h-full object-cover object-center"
              onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
